import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'

import './OnLineStatus.css'

class OnLineStatus extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      closed: true,
      onLine: true,
      shouldHide: false,
    }
    this.timeout = null
  }

  static getDerivedStateFromProps(props, state) {
    if (state.onLine !== props.onLine) {
      return {
        closed: false,
        onLine: props.onLine,
        shouldHide: props.onLine,
      }
    }
    return {
      shouldHide: false,
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  close = () => {
    clearTimeout(this.timeout)
    this.setState({
      closed: true,
      shouldHide: false,
    })
  }

  onCloseClick = () => {
    this.close()
  }

  startTimeoutToClose = () => {
    this.timeout = setTimeout(this.close, 3000)
  }

  render() {
    const { closed, shouldHide } = this.state
    const { onLine } = this.props

    if (shouldHide) {
      this.startTimeoutToClose()
    }

    return (
      <div className="OnLineStatus">
        {!closed && (
          <div className={`OnLineStatus__holder ${onLine ? 'online' : 'offline'}`}>
            <div className="OnLineStatus__holder__content">
              {onLine && <Icon color="grey" name="close" onClick={this.onCloseClick} />}
              {onLine ? 'Conectado a la red.' : 'Sin conexión a la red.'}
            </div>
          </div>
        )}
      </div>
    )
  }
}

OnLineStatus.propTypes = {
  onLine: PropTypes.bool.isRequired,
}

export default connect(({ environment: { onLine } }) => ({ onLine }))(OnLineStatus)
